
export const spStatus = [
  {id: 0, text: '进行中'},
  {id: 1, text: '暂停中'},
  {id: 4, text: '进行/暂停'},
  {id: 2, text: '已归档'}
];

export const spNegStatus = [
  {id: 0, text: '启用'},
  {id: 2, text: '已归档'},
];

export const spType = [
  {id: 1, text: '自动投放', color: '#34bfa3'},
  {id: 0, text: '手动投放', color: '#5986fb'},
];

export const spBidStrategy = [
  {id: 0, text: '动态竞价-只降低'},
  {id: 1, text: '动态竞价-提高和降低'},
  {id: 2, text: '固定竞价'},
];

// 是否超出预算
export const spServingStatus = [
  {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '是'},
  {id: 'OTHER', text: '否'},
];

export const spTargetType = [
  {id: '1', text: '关键词投放'},
  {id: '2', text: '商品投放'},
];

export const spMatchType = [
  {id: 0, text: '精确匹配'},
  {id: 2, text: '广泛匹配'},
  {id: 1, text: '词组匹配'},
];

export const spNegMatchType = [
  {id: 1, text: '否定词组'},
  {id: 0, text: '否定精确'}
];

export const searchType = [
  {id: 0, text: '模糊查询'},
  {id: 1, text: '精准查询'},
];

export const targetGroupType = [
  {id: 'QUERY_HIGH_REL_MATCHES', text: '紧密匹配', help: '我们会向使用与您的产品密切相关的搜索字词的购物者展示您的广告。 如果您的产品是“多普勒400支棉床单”，我们会在购物者使用“棉床单”和“400支床单”等搜索字词时展示广告。'},
  {id: 'QUERY_BROAD_REL_MATCHES', text: '宽泛匹配', help: '买家使用与您的商品并不密切相关的搜索词进行搜索时，我们会向其显示您的广告。 如果您的商品是“Doppler 400-count Cotton Sheets”，我们将在买家使用“bed sheets”、“bath sheets”和“bath towels”等搜索词时展示广告。'},
  {id: 'ASIN_SUBSTITUTE_RELATED', text: '同类商品', help: '买家查看与您的商品类似的商品的详情页面时，我们会向其展示您的广告。 如果您的商品是“Doppler 400-count Cotton Sheets”，我们将在包含“300-count Cotton Sheets”和“Queen 400-count Sheets”的商品详情页上展示广告。'},
  {id: 'ASIN_ACCESSORY_RELATED', text: '关联商品', help: '我们会向查看与您的产品相辅相成的产品详细信息页面的购物者展示您的广告。 如果您的产品是“多普勒400支棉床单”，我们将在包括“大床被”和“羽绒枕”的详细信息页面上展示广告。'}
];

export const effectivenessType = [
  {id: 0, text: '普通词'},
  {id: 1, text: '高效词'},
  {id: 2, text: '低效词'}
];

export const spBidType = [
  {id: 0, text: '建议竞价'},
  {id: 1, text: '默认竞价'}
];

const LOG_OP_ENM = {
  objectType: {
    CAMPAIGN: 1,
    GROUP: 2,
    PRODUCT: 3,
    KEYWORD: 4,
    NEG_KEYWORD: 5,
    CAMPAIGN_NEG_KEYWORD: 6,
    SEARCH_WORD: 7,
    PRODUCT_TARGET: 8,
    NEG_PRODUCT_TARGET: 9,
    TARGET_GROUP: 10
  }
};

export const LOG_OP_TYPE = {
  SP: {
    queryUrl: '/ads/adsSpLog/page',
    exportUrl: '/ads/adsSpLog/export',
    PORTFOLIO: [
      {id: 0, text: '新增广告组合'}
    ],
    CAMPAIGN: {
      opId: 'campaignId',
      objectType: LOG_OP_ENM.objectType.CAMPAIGN,
      opObjectTypeOption: [
        {id: LOG_OP_ENM.objectType.CAMPAIGN, text: '广告活动'},
        {id: LOG_OP_ENM.objectType.GROUP, text: '广告组'},
        {id: LOG_OP_ENM.objectType.PRODUCT, text: '商品'},
        {id: LOG_OP_ENM.objectType.KEYWORD, text: '关键词'},
        {id: LOG_OP_ENM.objectType.NEG_KEYWORD, text: '否定关键词'},
        {id: LOG_OP_ENM.objectType.CAMPAIGN_NEG_KEYWORD, text: '活动否定关键词'},
        // {id: LOG_OP_ENM.objectType.SEARCH_WORD, text: '用户搜索词'},
        {id: LOG_OP_ENM.objectType.PRODUCT_TARGET, text: '商品投放'},
        {id: LOG_OP_ENM.objectType.NEG_PRODUCT_TARGET, text: '否定商品投放'},
        {id: LOG_OP_ENM.objectType.TARGET_GROUP, text: '投放组'},
      ],
      opTypeOption: [
        {id: 0, text: '新增广告活动'},
        {id: 1, text: '调整预算'},
        {id: 2, text: '移动分组'},
        {id: 3, text: '修改结束日期'},
        {id: 4, text: '修改状态'},
        {id: 5, text: '修改活动名称'},
        {id: 6, text: '修改竞价策略'},
      ]
    },
    GROUP: {
      opId: 'groupId',
      objectType: LOG_OP_ENM.objectType.GROUP,
      opObjectTypeOption: [
        {id: LOG_OP_ENM.objectType.GROUP, text: '广告组'},
        {id: LOG_OP_ENM.objectType.PRODUCT, text: '商品'},
        {id: LOG_OP_ENM.objectType.KEYWORD, text: '关键词'},
        {id: LOG_OP_ENM.objectType.NEG_KEYWORD, text: '否定关键词'},
        // {id: LOG_OP_ENM.objectType.SEARCH_WORD, text: '用户搜索词'},
        {id: LOG_OP_ENM.objectType.PRODUCT_TARGET, text: '商品投放'},
        {id: LOG_OP_ENM.objectType.NEG_PRODUCT_TARGET, text: '否定商品投放'},
        {id: LOG_OP_ENM.objectType.TARGET_GROUP, text: '投放组'},
      ],
      opTypeOption: [
        {id: 7, text: '新增广告组'},
        {id: 8, text: '调整竞价'},
        {id: 4, text: '修改状态'},
        {id: 9, text: '修改广告组名称'},
      ]
    },
    PRODUCT: {
      opId: 'adId',
      objectType: LOG_OP_ENM.objectType.PRODUCT,
      opTypeOption: [
        {id: 10, text: '新增商品'},
        {id: 4, text: '修改状态'},
      ]
    },
    KEYWORD: {
      opId: 'keywordId',
      objectType: LOG_OP_ENM.objectType.KEYWORD,
      opTypeOption: [
        {id: 11, text: '新增关键词'},
        {id: 8, text: '调整竞价'},
        {id: 4, text: '修改状态'},
      ]
    },
    NEG_KEYWORD: {
      opId: 'negativeKeywordId',
      objectType: LOG_OP_ENM.objectType.NEG_KEYWORD,
      opTypeOption: [
        {id: 12, text: '新增否定关键词'},
        {id: 4, text: '修改状态'},
      ]
    },
    CAMPAIGN_NEG_KEYWORD: {
      opId: 'negativeKeywordId',
      objectType: LOG_OP_ENM.objectType.CAMPAIGN_NEG_KEYWORD,
      opTypeOption: [
        {id: 12, text: '新增否定关键词'},
        {id: 4, text: '修改状态'},
      ]
    },
    SEARCH_WORD: [
      {id: 0, text: '设为关键词'},
      {id: 1, text: '设为否定关键词'},
    ],
    PRODUCT_TARGET: {
      opId: 'targetId',
      objectType: LOG_OP_ENM.objectType.PRODUCT_TARGET,
      opTypeOption: [
        {id: 13, text: '新增商品投放'},
        {id: 8, text: '调整竞价'},
        {id: 4, text: '修改状态'},
      ]
    },
    NEG_PRODUCT_TARGET: {
      opId: 'negativeTargetId',
      objectType: LOG_OP_ENM.objectType.NEG_PRODUCT_TARGET,
      opTypeOption: [
        {id: 14, text: '新增否定商品投放'},
        {id: 4, text: '修改状态'},
      ]
    },
    TARGET_GROUP: {
      opId: 'targetId',
      objectType: LOG_OP_ENM.objectType.TARGET_GROUP,
      opTypeOption: [
        {id: 8, text: '调整竞价'},
        {id: 4, text: '修改状态'},
      ]
    }
  },
  SD: {
    queryUrl: '/ads/adsSdLog/page',
    exportUrl: '/ads/adsSdLog/export',
    CAMPAIGN: {
      opId: 'campaignId',
      objectType: LOG_OP_ENM.objectType.CAMPAIGN,
      opObjectTypeOption: [
        {id: LOG_OP_ENM.objectType.CAMPAIGN, text: '广告活动'},
        {id: LOG_OP_ENM.objectType.GROUP, text: '广告组'},
        {id: LOG_OP_ENM.objectType.PRODUCT, text: '商品'},
        // {id: LOG_OP_ENM.objectType.SEARCH_WORD, text: '用户搜索词'},
        {id: LOG_OP_ENM.objectType.PRODUCT_TARGET, text: '商品投放'},
        {id: LOG_OP_ENM.objectType.NEG_PRODUCT_TARGET, text: '否定商品投放'},
      ],
      opTypeOption: [
        {id: 0, text: '新增广告活动'},
        {id: 1, text: '调整预算'},
        {id: 3, text: '修改结束日期'},
        {id: 4, text: '修改状态'},
        {id: 5, text: '修改活动名称'},
      ]
    },
    GROUP: {
      opId: 'groupId',
      objectType: LOG_OP_ENM.objectType.GROUP,
      opObjectTypeOption: [
        {id: LOG_OP_ENM.objectType.GROUP, text: '广告组'},
        {id: LOG_OP_ENM.objectType.PRODUCT, text: '商品'},
        {id: LOG_OP_ENM.objectType.PRODUCT_TARGET, text: '商品投放'},
        {id: LOG_OP_ENM.objectType.NEG_PRODUCT_TARGET, text: '否定商品投放'},
      ],
      opTypeOption: [
        {id: 1, text: '新增广告组'},
        {id: 2, text: '调整竞价'},
        {id: 3, text: '修改状态'},
        {id: 4, text: '修改广告组名称'},
      ]
    },
    PRODUCT: {
      opId: 'adId',
      objectType: LOG_OP_ENM.objectType.PRODUCT,
      opTypeOption: [
        {id: 0, text: '新增商品'},
        {id: 1, text: '修改状态'},
      ]
    },
    PRODUCT_TARGET: {
      opId: 'targetId',
      objectType: LOG_OP_ENM.objectType.PRODUCT_TARGET,
      opTypeOption: [
        {id: 0, text: '新增商品投放'},
        {id: 1, text: '调整竞价'},
        {id: 2, text: '修改状态'},
      ]
    },
    NEG_PRODUCT_TARGET: {
      opId: 'negativeTargetId',
      objectType: LOG_OP_ENM.objectType.NEG_PRODUCT_TARGET,
      opTypeOption: [
        {id: 0, text: '新增否定商品投放'},
        {id: 1, text: '修改状态'},
      ]
    },
  },
  SB: {
    queryUrl: '/ads/adsSbLog/page',
    exportUrl: '/ads/adsSbLog/export',
    CAMPAIGN: {
      opId: 'campaignId',
      objectType: LOG_OP_ENM.objectType.CAMPAIGN,
      opObjectTypeOption: [
        {id: LOG_OP_ENM.objectType.CAMPAIGN, text: '广告活动'},
        {id: LOG_OP_ENM.objectType.KEYWORD, text: '关键词'},
        {id: LOG_OP_ENM.objectType.NEG_KEYWORD, text: '否定关键词'},
        {id: LOG_OP_ENM.objectType.PRODUCT_TARGET, text: '商品投放'},
        {id: LOG_OP_ENM.objectType.NEG_PRODUCT_TARGET, text: '否定商品投放'},
        {id: 11, text: '广告活动草稿'},
      ],
      opTypeOption: [
        {id: 1, text: '调整预算'},
        {id: 2, text: '移动分组'},
        {id: 3, text: '修改结束日期'},
        {id: 4, text: '修改状态'},
        {id: 5, text: '修改活动名称'}
      ]
    },
    KEYWORD: {
      opId: 'keywordId',
      objectType: LOG_OP_ENM.objectType.KEYWORD,
      opObjectTypeOption: [
        {id: LOG_OP_ENM.objectType.KEYWORD, text: '关键词'}
      ],
      opTypeOption: [
        {id: 0, text: '新增关键词'},
        {id: 1, text: '调整竞价'},
        {id: 2, text: '修改状态'},
      ]
    },
    NEG_KEYWORD: {
      opId: 'negativeKeywordId',
      objectType: LOG_OP_ENM.objectType.NEG_KEYWORD,
      opObjectTypeOption: [
        {id: LOG_OP_ENM.objectType.NEG_KEYWORD, text: '否定关键词'},
      ],
      opTypeOption: [
        {id: 0, text: '修改状态'},
      ]
    },
    PRODUCT_TARGET: {
      opId: 'targetId',
      objectType: LOG_OP_ENM.objectType.PRODUCT_TARGET,
      opObjectTypeOption: [
        {id: LOG_OP_ENM.objectType.PRODUCT_TARGET, text: '商品投放'}
      ],
      opTypeOption: [
        {id: 4, text: '修改状态'},
        {id: 8, text: '调整竞价'},
        {id: 13, text: '新增商品投放'},
      ]
    },
    NEG_PRODUCT_TARGET: {
      opId: 'negativeTargetId',
      objectType: LOG_OP_ENM.objectType.NEG_PRODUCT_TARGET,
      opObjectTypeOption: [
        {id: LOG_OP_ENM.objectType.NEG_PRODUCT_TARGET, text: '否定商品投放'},
      ],
      opTypeOption: [
        {id: 4, text: '修改状态'},
        {id: 14, text: '新增否定商品投放'},
      ]
    }
  }
};







